module.exports = __webpack_public_path__ + "static/media/LOGO.e5e05abc.svg";